import VueScrollTo from 'vue-scrollto';


export const setScrollingState = ({ commit }, state) => {
  commit('setScrollingState', state);
};

export const scrollToSection = (store, { section, options }) => {
  const el = document.querySelector(`#section-${section}`);
  VueScrollTo.scrollTo(el, 500, options);
};
